<template>
  <div>
    <v-text-field
      :value="value.title"
      label="Section Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <div class="mb-2 font-weight-medium">FAQ Items</div>
    <v-card v-for="(item, i) in items" :key="i" outlined class="mb-2 pa-3">
      <v-row dense>
        <v-col cols="11">
          <v-text-field
            :value="item.question || item.q"
            label="Question"
            outlined
            dense
            @input="updateItem(i, 'question', $event)"
          />
          <v-textarea
            :value="item.answer || item.a"
            label="Answer"
            outlined
            dense
            rows="2"
            @input="updateItem(i, 'answer', $event)"
          />
        </v-col>
        <v-col cols="1" class="d-flex align-center">
          <v-btn icon small color="error" @click="removeItem(i)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-btn text small color="primary" @click="addItem">
      <v-icon small left>mdi-plus</v-icon>Add FAQ
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
  },
  computed: {
    items() {
      return this.value.items || [];
    },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    addItem() {
      if (this.items.length > 0) {
        const lastItem = this.items[this.items.length - 1];
        const lastQ = lastItem.question || lastItem.q || "";
        if (lastQ.trim() === "") {
          this.$swal ? this.$swal("Validation Error", "Please fill the question of the last FAQ before adding a new one.", "error") : alert("Please fill the question of the last FAQ before adding a new one.");
          return;
        }
      }
      this.$emit("input", {
        ...this.value,
        items: [...this.items, { question: "", answer: "" }],
      });
    },
    removeItem(i) {
      this.$emit("input", {
        ...this.value,
        items: this.items.filter((_, idx) => idx !== i),
      });
    },
    updateItem(i, key, val) {
      var items = this.items.map((item, idx) =>
        idx === i ? { ...item, [key]: val } : item
      );
      this.$emit("input", { ...this.value, items });
    },
  },
};
</script>
